import * as types from 'store/actions/types';
import * as fetchMembershipSchedules from 'store/actions/membership-schedules/fetchMembershipSchedules';
import * as createMembershipSchedules from 'store/actions/membership-schedules/createMembershipSchedules';
import * as deleteMembershipSchedules from 'store/actions/membership-schedules/deleteMembershipSchedules';
import * as updateMembershipSchedule from 'store/actions/membership-schedules/updateMembershipSchedules';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import utils from 'helpers/utils';

function* failureMessage({ error }) {
    const { message } = error.response || {};

    yield put(showNotification(message || 'general.error', 'warning'));
}

function* fetchMembershipSchedulesAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/membership-schedules`;

        const response = yield apiClient.read(url, payload);

        yield put(fetchMembershipSchedules.fetchMembershipSchedulesSuccess(response));
    } catch (error) {
        yield put(fetchMembershipSchedules.fetchMembershipSchedulesFailure(error));
    }
}

function* fetchMembershipScheduleAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/membership-schedules/${ id }`;

        const response = yield apiClient.read(url);

        yield put(fetchMembershipSchedules.fetchMembershipScheduleSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }

    } catch (error) {
        yield put(fetchMembershipSchedules.fetchMembershipScheduleFailure(error));

        if (utils.isFunction(error)) {
            yield onError(error);
        }
    }
}

function* createMembershipScheduleAsync({ payload }) {
    const {
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/membership-schedules`;

        const response = yield apiClient.create(url, values);

        yield put(createMembershipSchedules.createMembershipScheduleSuccess(response));

        yield onSuccess();
    } catch (error) {
        yield put(createMembershipSchedules.createMembershipScheduleFailure(error));

        yield onError(error);
    }
}

function* createMembershipScheduleSuccessAsync() {
    yield put(showNotification('resources.membership_schedules.messages.created.success', 'success'));
}

function* deleteMembershipScheduleAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/membership-schedules/${ id }`;

        yield apiClient.delete(url);

        yield put(deleteMembershipSchedules.deleteMembershipScheduleSuccess(payload));

        yield onSuccess();
    } catch (error) {
        yield put(deleteMembershipSchedules.deleteMembershipScheduleFailure(error));

        if (utils.isFunction(error)) {
            yield onError(error);
        }
    }
}

function* updateMembershipScheduleAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/membership-schedules/${ id }`;

        const response = yield apiClient.patch(url, values);

        yield put(updateMembershipSchedule.updateMembershipScheduleSuccess(payload, response));

        yield onSuccess();
    } catch (error) {
        yield put(updateMembershipSchedule.updateMembershipScheduleFailure(error));

        yield onError(error);
    }
}

function* updateMembershipScheduleSuccessAsync() {
    yield put(showNotification('resources.membership_schedules.messages.updated.success', 'success'));
}

function* deleteMembershipScheduleSuccessAsync() {
    yield put(showNotification('resources.membership_schedules.messages.deleted.success', 'success'));
}

export default function* membershipSchedulesSagas() {
    yield [
        takeEvery(types.FETCH_MEMBERSHIP_SCHEDULES, fetchMembershipSchedulesAsync),
        takeEvery(types.FETCH_MEMBERSHIP_SCHEDULES_FAILURE, failureMessage),

        takeEvery(types.FETCH_MEMBERSHIP_SCHEDULE, fetchMembershipScheduleAsync),
        takeEvery(types.FETCH_MEMBERSHIP_SCHEDULE_FAILURE, failureMessage),

        takeEvery(types.CREATE_MEMBERSHIP_SCHEDULE, createMembershipScheduleAsync),
        takeEvery(types.CREATE_MEMBERSHIP_SCHEDULE_FAILURE, failureMessage),
        takeEvery(types.CREATE_MEMBERSHIP_SCHEDULE_SUCCESS, createMembershipScheduleSuccessAsync),

        takeEvery(types.UPDATE_MEMBERSHIP_SCHEDULE, updateMembershipScheduleAsync),
        takeEvery(types.UPDATE_MEMBERSHIP_SCHEDULE_FAILURE, failureMessage),
        takeEvery(types.UPDATE_MEMBERSHIP_SCHEDULE_SUCCESS, updateMembershipScheduleSuccessAsync),

        takeEvery(types.DELETE_MEMBERSHIP_SCHEDULE, deleteMembershipScheduleAsync),
        takeEvery(types.DELETE_MEMBERSHIP_SCHEDULE_FAILURE, failureMessage),
        takeEvery(types.DELETE_MEMBERSHIP_SCHEDULE_SUCCESS, deleteMembershipScheduleSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/membershipSchedulesSagas.js